export default {
  relatedMetals: {
    id: 'rm_metal_related_metals_title',
    defaultMessage: 'Related Metals',
  },
} as const
